import store from "../../../store";
import bolt_dine_export from './bolt_dine_export.vue';

window.bolt_dine_export =  new Vue({
    store,
    el: 'div#bolt_dine_export',

    name : "bolt_dine_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        bolt_dine_export,
    }
});
